$w.onReady(function () {
    $w("#button26").onClick(() => {
        $w("#statebox1").changeState("state1");
    });

    $w("#button24").onClick(() => {
        $w("#statebox1").changeState("state2");
    });
});